import { default as indexFADheRMvXIMeta } from "/vercel/path0/pages/app/chat/index.vue?macro=true";
import { default as detail65A73stnEkMeta } from "/vercel/path0/pages/app/content/[id]/detail.vue?macro=true";
import { default as indexcfTliEyvhiMeta } from "/vercel/path0/pages/app/content/[id]/index.vue?macro=true";
import { default as editorchzoOdJRNFMeta } from "/vercel/path0/pages/app/content/editor.vue?macro=true";
import { default as _91id_93GXTklDBwAuMeta } from "/vercel/path0/pages/app/content/v2/[id].vue?macro=true";
import { default as indexmffWzFmT5TMeta } from "/vercel/path0/pages/app/dining/banned/index.vue?macro=true";
import { default as _91orderId_937Pp6wYY7NTMeta } from "/vercel/path0/pages/app/dining/feedback/[orderId].vue?macro=true";
import { default as report_45memberEJ2he3eDEaMeta } from "/vercel/path0/pages/app/dining/feedback/report-member.vue?macro=true";
import { default as indexD4zLumX2LAMeta } from "/vercel/path0/pages/app/dining/index.vue?macro=true";
import { default as detailgseffT49suMeta } from "/vercel/path0/pages/app/dining/introduction/detail.vue?macro=true";
import { default as kakao_45loginyOg43src1sMeta } from "/vercel/path0/pages/app/dining/kakao-login.vue?macro=true";
import { default as _91orderId_934x4KQLDFd8Meta } from "/vercel/path0/pages/app/dining/order/[orderId].vue?macro=true";
import { default as listQJUw0lej54Meta } from "/vercel/path0/pages/app/dining/order/list.vue?macro=true";
import { default as confirmV3tFFiJ0VUMeta } from "/vercel/path0/pages/app/dining/payment/confirm.vue?macro=true";
import { default as fail941rbU9KHnMeta } from "/vercel/path0/pages/app/dining/payment/fail.vue?macro=true";
import { default as in_45progressQm1IF0B0OiMeta } from "/vercel/path0/pages/app/dining/payment/in-progress.vue?macro=true";
import { default as indexKPKfzHPc5BMeta } from "/vercel/path0/pages/app/dining/payment/index.vue?macro=true";
import { default as methodXVoIpKCHDNMeta } from "/vercel/path0/pages/app/dining/payment/method.vue?macro=true";
import { default as select_45areaUPRVjqQUKKMeta } from "/vercel/path0/pages/app/dining/payment/select-area.vue?macro=true";
import { default as successmPJzRuMgSHMeta } from "/vercel/path0/pages/app/dining/payment/success.vue?macro=true";
import { default as policy12aCvbivQ5Meta } from "/vercel/path0/pages/app/dining/policy.vue?macro=true";
import { default as store0od2qukRiFMeta } from "/vercel/path0/pages/app/emoticon/store.vue?macro=true";
import { default as _50percentqrVuaxu5h4Meta } from "/vercel/path0/pages/app/event/50percent.vue?macro=true";
import { default as _91id_93EynO6Hv8wnMeta } from "/vercel/path0/pages/app/hotdeal/[id].vue?macro=true";
import { default as indexxpD6ED4x3AMeta } from "/vercel/path0/pages/app/hotdeal/address/edit/index.vue?macro=true";
import { default as searchEYuHtv8VLDMeta } from "/vercel/path0/pages/app/hotdeal/address/edit/search.vue?macro=true";
import { default as personal_45informationK3enT7geNtMeta } from "/vercel/path0/pages/app/hotdeal/agreement/personal-information.vue?macro=true";
import { default as etc_45infofR9YKRLFLNMeta } from "/vercel/path0/pages/app/hotdeal/etc-info.vue?macro=true";
import { default as indexpH2Evgy4MpMeta } from "/vercel/path0/pages/app/hotdeal/index.vue?macro=true";
import { default as failDODPTnAkPwMeta } from "/vercel/path0/pages/app/hotdeal/payment/fail.vue?macro=true";
import { default as in_45progressldTvMSexvWMeta } from "/vercel/path0/pages/app/hotdeal/payment/in-progress.vue?macro=true";
import { default as indexofhHEjmMWzMeta } from "/vercel/path0/pages/app/hotdeal/payment/index.vue?macro=true";
import { default as methodZ3mXj9HPDDMeta } from "/vercel/path0/pages/app/hotdeal/payment/method.vue?macro=true";
import { default as indexUtKdzYthKWMeta } from "/vercel/path0/pages/app/kgInicis/index.vue?macro=true";
import { default as finderYjJP3a6R8SMeta } from "/vercel/path0/pages/app/map/finder.vue?macro=true";
import { default as readerFfqkBKgkVQMeta } from "/vercel/path0/pages/app/map/reader.vue?macro=true";
import { default as view0Q9OZGdJo7Meta } from "/vercel/path0/pages/app/map/view.vue?macro=true";
import { default as _52628_44032__54876_46041_44428__44396_46021__51221_52293__48320_44221__50504_45236wxQeG6mb8VMeta } from "/vercel/path0/pages/app/notice/추가_활동권_구독_정책_변경_안내.vue?macro=true";
import { default as open_45new_45browsertByCVaCx27Meta } from "/vercel/path0/pages/app/open-new-browser.vue?macro=true";
import { default as _91id_93AFKXdl6Hw6Meta } from "/vercel/path0/pages/app/preview/gathering/[id].vue?macro=true";
import { default as _91id_9332Y8GQyrfIMeta } from "/vercel/path0/pages/app/preview/gathering/feed/[id].vue?macro=true";
import { default as list81GoBlF6wFMeta } from "/vercel/path0/pages/app/preview/gathering/feed/list.vue?macro=true";
import { default as listfGK83VrEmLMeta } from "/vercel/path0/pages/app/preview/gathering/list.vue?macro=true";
import { default as index1n9tDgXaK6Meta } from "/vercel/path0/pages/app/preview/index.vue?macro=true";
import { default as service_45unavailableRURpclmL0VMeta } from "/vercel/path0/pages/app/service-unavailable.vue?macro=true";
import { default as activityDhZzEhmjgcMeta } from "/vercel/path0/pages/app/subscription/activity.vue?macro=true";
import { default as gatheringkqUeSGjRyhMeta } from "/vercel/path0/pages/app/subscription/gathering.vue?macro=true";
import { default as what_45is_45oeONFzb7LdB6Meta } from "/vercel/path0/pages/app/what-is-oe.vue?macro=true";
import { default as dues_45differencegEP3MIvh5MMeta } from "/vercel/path0/pages/article/dues-difference.vue?macro=true";
import { default as gathering_45limitGwRDEWcKpvMeta } from "/vercel/path0/pages/article/gathering-limit.vue?macro=true";
import { default as gathering_45settingPwgkPWNVHtMeta } from "/vercel/path0/pages/article/gathering-setting.vue?macro=true";
import { default as identity_45noticeqAeKXhZu9jMeta } from "/vercel/path0/pages/article/identity-notice.vue?macro=true";
import { default as membership_45notice9UYWe17cdUMeta } from "/vercel/path0/pages/article/membership-notice.vue?macro=true";
import { default as our_45valueWRaHyvxgyLMeta } from "/vercel/path0/pages/article/our-value.vue?macro=true";
import { default as staff_45concernfapUWyT0PUMeta } from "/vercel/path0/pages/article/staff-concern.vue?macro=true";
import { default as redirectKZlZV2IttaMeta } from "/vercel/path0/pages/auth/kakao/redirect.vue?macro=true";
import { default as emoticon_45bannerrHySCRLeJ7Meta } from "/vercel/path0/pages/banner/emoticon-banner.vue?macro=true";
import { default as _91id_93bVyATJrmnRMeta } from "/vercel/path0/pages/content/[id].vue?macro=true";
import { default as for_45appLD2f3WrIbGMeta } from "/vercel/path0/pages/content/host/introduce/for-app.vue?macro=true";
import { default as indexPQ86JAPjvRMeta } from "/vercel/path0/pages/content/host/introduce/index.vue?macro=true";
import { default as customerServiceDiz8qLItvpMeta } from "/vercel/path0/pages/customerService.vue?macro=true";
import { default as _91id_930ekg58uS4iMeta } from "/vercel/path0/pages/gathering/[id].vue?macro=true";
import { default as _91id_93c6qGe124SmMeta } from "/vercel/path0/pages/gathering/ai-recommend-schedule/[id].vue?macro=true";
import { default as _91id_93bZWdTBZ7oWMeta } from "/vercel/path0/pages/gathering/feed/[id].vue?macro=true";
import { default as listvHI6cfzy7SMeta } from "/vercel/path0/pages/gathering/feed/list.vue?macro=true";
import { default as listhEDqx6uSPhMeta } from "/vercel/path0/pages/gathering/list.vue?macro=true";
import { default as notfoundmui9CxnzfvMeta } from "/vercel/path0/pages/gathering/notfound.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as introduceOEgc21NtHKqjMeta } from "/vercel/path0/pages/introduceOE.vue?macro=true";
import { default as _91groupId_93ObTK6GlMXtMeta } from "/vercel/path0/pages/product/emoticon/[groupId].vue?macro=true";
import { default as _91id_93dRjblFD3G3Meta } from "/vercel/path0/pages/promotion/[id].vue?macro=true";
import { default as make_45gatheringKi9ND3TwiiMeta } from "/vercel/path0/pages/promotion/make-gathering.vue?macro=true";
import { default as myLifeConcertd0jP9PUcTrMeta } from "/vercel/path0/pages/promotion/myLifeConcert.vue?macro=true";
import { default as chat_45roomqp3ngWOcRZMeta } from "/vercel/path0/pages/publishing/chat-room.vue?macro=true";
import { default as beforePjE8xXuqy8Meta } from "/vercel/path0/pages/recommend/login/before.vue?macro=true";
import { default as indexWfWPOnXromMeta } from "/vercel/path0/pages/recommend/login/index.vue?macro=true";
import { default as scheduleEqjSVGVY89Meta } from "/vercel/path0/pages/recommend/result/schedule.vue?macro=true";
import { default as waiting3NiRKx8rNyMeta } from "/vercel/path0/pages/recommend/result/waiting.vue?macro=true";
import { default as searchingPZqz8F16LGMeta } from "/vercel/path0/pages/recommend/searching.vue?macro=true";
import { default as surveyxzbXjR3y1qMeta } from "/vercel/path0/pages/recommend/survey.vue?macro=true";
import { default as _91to_93h7Ge65gs6CMeta } from "/vercel/path0/pages/redirect/[platform]/[to].vue?macro=true";
export default [
  {
    name: "app-chat",
    path: "/app/chat",
    meta: indexFADheRMvXIMeta || {},
    component: () => import("/vercel/path0/pages/app/chat/index.vue")
  },
  {
    name: "app-content-id-detail",
    path: "/app/content/:id()/detail",
    component: () => import("/vercel/path0/pages/app/content/[id]/detail.vue")
  },
  {
    name: "app-content-id",
    path: "/app/content/:id()",
    component: () => import("/vercel/path0/pages/app/content/[id]/index.vue")
  },
  {
    name: "app-content-editor",
    path: "/app/content/editor",
    component: () => import("/vercel/path0/pages/app/content/editor.vue")
  },
  {
    name: "app-content-v2-id",
    path: "/app/content/v2/:id()",
    component: () => import("/vercel/path0/pages/app/content/v2/[id].vue")
  },
  {
    name: "app-dining-banned",
    path: "/app/dining/banned",
    component: () => import("/vercel/path0/pages/app/dining/banned/index.vue")
  },
  {
    name: "app-dining-feedback-orderId",
    path: "/app/dining/feedback/:orderId()",
    component: () => import("/vercel/path0/pages/app/dining/feedback/[orderId].vue")
  },
  {
    name: "app-dining-feedback-report-member",
    path: "/app/dining/feedback/report-member",
    component: () => import("/vercel/path0/pages/app/dining/feedback/report-member.vue")
  },
  {
    name: "app-dining",
    path: "/app/dining",
    component: () => import("/vercel/path0/pages/app/dining/index.vue")
  },
  {
    name: "app-dining-introduction-detail",
    path: "/app/dining/introduction/detail",
    component: () => import("/vercel/path0/pages/app/dining/introduction/detail.vue")
  },
  {
    name: "app-dining-kakao-login",
    path: "/app/dining/kakao-login",
    component: () => import("/vercel/path0/pages/app/dining/kakao-login.vue")
  },
  {
    name: "app-dining-order-orderId",
    path: "/app/dining/order/:orderId()",
    component: () => import("/vercel/path0/pages/app/dining/order/[orderId].vue")
  },
  {
    name: "app-dining-order-list",
    path: "/app/dining/order/list",
    component: () => import("/vercel/path0/pages/app/dining/order/list.vue")
  },
  {
    name: "app-dining-payment-confirm",
    path: "/app/dining/payment/confirm",
    component: () => import("/vercel/path0/pages/app/dining/payment/confirm.vue")
  },
  {
    name: "app-dining-payment-fail",
    path: "/app/dining/payment/fail",
    component: () => import("/vercel/path0/pages/app/dining/payment/fail.vue")
  },
  {
    name: "app-dining-payment-in-progress",
    path: "/app/dining/payment/in-progress",
    component: () => import("/vercel/path0/pages/app/dining/payment/in-progress.vue")
  },
  {
    name: "app-dining-payment",
    path: "/app/dining/payment",
    component: () => import("/vercel/path0/pages/app/dining/payment/index.vue")
  },
  {
    name: "app-dining-payment-method",
    path: "/app/dining/payment/method",
    component: () => import("/vercel/path0/pages/app/dining/payment/method.vue")
  },
  {
    name: "app-dining-payment-select-area",
    path: "/app/dining/payment/select-area",
    component: () => import("/vercel/path0/pages/app/dining/payment/select-area.vue")
  },
  {
    name: "app-dining-payment-success",
    path: "/app/dining/payment/success",
    component: () => import("/vercel/path0/pages/app/dining/payment/success.vue")
  },
  {
    name: "app-dining-policy",
    path: "/app/dining/policy",
    component: () => import("/vercel/path0/pages/app/dining/policy.vue")
  },
  {
    name: "app-emoticon-store",
    path: "/app/emoticon/store",
    component: () => import("/vercel/path0/pages/app/emoticon/store.vue")
  },
  {
    name: "app-event-50percent",
    path: "/app/event/50percent",
    component: () => import("/vercel/path0/pages/app/event/50percent.vue")
  },
  {
    name: "app-hotdeal-id",
    path: "/app/hotdeal/:id()",
    meta: _91id_93EynO6Hv8wnMeta || {},
    component: () => import("/vercel/path0/pages/app/hotdeal/[id].vue")
  },
  {
    name: "app-hotdeal-address-edit",
    path: "/app/hotdeal/address/edit",
    component: () => import("/vercel/path0/pages/app/hotdeal/address/edit/index.vue")
  },
  {
    name: "app-hotdeal-address-edit-search",
    path: "/app/hotdeal/address/edit/search",
    component: () => import("/vercel/path0/pages/app/hotdeal/address/edit/search.vue")
  },
  {
    name: "app-hotdeal-agreement-personal-information",
    path: "/app/hotdeal/agreement/personal-information",
    component: () => import("/vercel/path0/pages/app/hotdeal/agreement/personal-information.vue")
  },
  {
    name: "app-hotdeal-etc-info",
    path: "/app/hotdeal/etc-info",
    component: () => import("/vercel/path0/pages/app/hotdeal/etc-info.vue")
  },
  {
    name: "app-hotdeal",
    path: "/app/hotdeal",
    meta: indexpH2Evgy4MpMeta || {},
    component: () => import("/vercel/path0/pages/app/hotdeal/index.vue")
  },
  {
    name: "app-hotdeal-payment-fail",
    path: "/app/hotdeal/payment/fail",
    component: () => import("/vercel/path0/pages/app/hotdeal/payment/fail.vue")
  },
  {
    name: "app-hotdeal-payment-in-progress",
    path: "/app/hotdeal/payment/in-progress",
    component: () => import("/vercel/path0/pages/app/hotdeal/payment/in-progress.vue")
  },
  {
    name: "app-hotdeal-payment",
    path: "/app/hotdeal/payment",
    component: () => import("/vercel/path0/pages/app/hotdeal/payment/index.vue")
  },
  {
    name: "app-hotdeal-payment-method",
    path: "/app/hotdeal/payment/method",
    component: () => import("/vercel/path0/pages/app/hotdeal/payment/method.vue")
  },
  {
    name: "app-kgInicis",
    path: "/app/kgInicis",
    component: () => import("/vercel/path0/pages/app/kgInicis/index.vue")
  },
  {
    name: "app-map-finder",
    path: "/app/map/finder",
    component: () => import("/vercel/path0/pages/app/map/finder.vue")
  },
  {
    name: "app-map-reader",
    path: "/app/map/reader",
    component: () => import("/vercel/path0/pages/app/map/reader.vue")
  },
  {
    name: "app-map-view",
    path: "/app/map/view",
    component: () => import("/vercel/path0/pages/app/map/view.vue")
  },
  {
    name: "app-notice-추가_활동권_구독_정책_변경_안내",
    path: "/app/notice/%EC%B6%94%EA%B0%80_%ED%99%9C%EB%8F%99%EA%B6%8C_%EA%B5%AC%EB%8F%85_%EC%A0%95%EC%B1%85_%EB%B3%80%EA%B2%BD_%EC%95%88%EB%82%B4",
    component: () => import("/vercel/path0/pages/app/notice/추가_활동권_구독_정책_변경_안내.vue")
  },
  {
    name: "app-open-new-browser",
    path: "/app/open-new-browser",
    component: () => import("/vercel/path0/pages/app/open-new-browser.vue")
  },
  {
    name: "app-preview-gathering-id",
    path: "/app/preview/gathering/:id()",
    meta: _91id_93AFKXdl6Hw6Meta || {},
    component: () => import("/vercel/path0/pages/app/preview/gathering/[id].vue")
  },
  {
    name: "app-preview-gathering-feed-id",
    path: "/app/preview/gathering/feed/:id()",
    meta: _91id_9332Y8GQyrfIMeta || {},
    component: () => import("/vercel/path0/pages/app/preview/gathering/feed/[id].vue")
  },
  {
    name: "app-preview-gathering-feed-list",
    path: "/app/preview/gathering/feed/list",
    meta: list81GoBlF6wFMeta || {},
    component: () => import("/vercel/path0/pages/app/preview/gathering/feed/list.vue")
  },
  {
    name: "app-preview-gathering-list",
    path: "/app/preview/gathering/list",
    meta: listfGK83VrEmLMeta || {},
    component: () => import("/vercel/path0/pages/app/preview/gathering/list.vue")
  },
  {
    name: "app-preview",
    path: "/app/preview",
    component: () => import("/vercel/path0/pages/app/preview/index.vue")
  },
  {
    name: "app-service-unavailable",
    path: "/app/service-unavailable",
    component: () => import("/vercel/path0/pages/app/service-unavailable.vue")
  },
  {
    name: "app-subscription-activity",
    path: "/app/subscription/activity",
    meta: activityDhZzEhmjgcMeta || {},
    component: () => import("/vercel/path0/pages/app/subscription/activity.vue")
  },
  {
    name: "app-subscription-gathering",
    path: "/app/subscription/gathering",
    meta: gatheringkqUeSGjRyhMeta || {},
    component: () => import("/vercel/path0/pages/app/subscription/gathering.vue")
  },
  {
    name: "app-what-is-oe",
    path: "/app/what-is-oe",
    component: () => import("/vercel/path0/pages/app/what-is-oe.vue")
  },
  {
    name: "article-dues-difference",
    path: "/article/dues-difference",
    meta: dues_45differencegEP3MIvh5MMeta || {},
    component: () => import("/vercel/path0/pages/article/dues-difference.vue")
  },
  {
    name: "article-gathering-limit",
    path: "/article/gathering-limit",
    meta: gathering_45limitGwRDEWcKpvMeta || {},
    component: () => import("/vercel/path0/pages/article/gathering-limit.vue")
  },
  {
    name: "article-gathering-setting",
    path: "/article/gathering-setting",
    meta: gathering_45settingPwgkPWNVHtMeta || {},
    component: () => import("/vercel/path0/pages/article/gathering-setting.vue")
  },
  {
    name: "article-identity-notice",
    path: "/article/identity-notice",
    meta: identity_45noticeqAeKXhZu9jMeta || {},
    component: () => import("/vercel/path0/pages/article/identity-notice.vue")
  },
  {
    name: "article-membership-notice",
    path: "/article/membership-notice",
    meta: membership_45notice9UYWe17cdUMeta || {},
    component: () => import("/vercel/path0/pages/article/membership-notice.vue")
  },
  {
    name: "article-our-value",
    path: "/article/our-value",
    meta: our_45valueWRaHyvxgyLMeta || {},
    component: () => import("/vercel/path0/pages/article/our-value.vue")
  },
  {
    name: "article-staff-concern",
    path: "/article/staff-concern",
    meta: staff_45concernfapUWyT0PUMeta || {},
    component: () => import("/vercel/path0/pages/article/staff-concern.vue")
  },
  {
    name: "auth-kakao-redirect",
    path: "/auth/kakao/redirect",
    component: () => import("/vercel/path0/pages/auth/kakao/redirect.vue")
  },
  {
    name: "banner-emoticon-banner",
    path: "/banner/emoticon-banner",
    component: () => import("/vercel/path0/pages/banner/emoticon-banner.vue")
  },
  {
    name: "content-id",
    path: "/content/:id()",
    component: () => import("/vercel/path0/pages/content/[id].vue")
  },
  {
    name: "content-host-introduce-for-app",
    path: "/content/host/introduce/for-app",
    component: () => import("/vercel/path0/pages/content/host/introduce/for-app.vue")
  },
  {
    name: "content-host-introduce",
    path: "/content/host/introduce",
    component: () => import("/vercel/path0/pages/content/host/introduce/index.vue")
  },
  {
    name: "customerService",
    path: "/customerService",
    component: () => import("/vercel/path0/pages/customerService.vue")
  },
  {
    name: "gathering-id",
    path: "/gathering/:id()",
    component: () => import("/vercel/path0/pages/gathering/[id].vue")
  },
  {
    name: "gathering-ai-recommend-schedule-id",
    path: "/gathering/ai-recommend-schedule/:id()",
    component: () => import("/vercel/path0/pages/gathering/ai-recommend-schedule/[id].vue")
  },
  {
    name: "gathering-feed-id",
    path: "/gathering/feed/:id()",
    component: () => import("/vercel/path0/pages/gathering/feed/[id].vue")
  },
  {
    name: "gathering-feed-list",
    path: "/gathering/feed/list",
    component: () => import("/vercel/path0/pages/gathering/feed/list.vue")
  },
  {
    name: "gathering-list",
    path: "/gathering/list",
    component: () => import("/vercel/path0/pages/gathering/list.vue")
  },
  {
    name: "gathering-notfound",
    path: "/gathering/notfound",
    component: () => import("/vercel/path0/pages/gathering/notfound.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "introduceOE",
    path: "/introduceOE",
    component: () => import("/vercel/path0/pages/introduceOE.vue")
  },
  {
    name: "product-emoticon-groupId",
    path: "/product/emoticon/:groupId()",
    component: () => import("/vercel/path0/pages/product/emoticon/[groupId].vue")
  },
  {
    name: "promotion-id",
    path: "/promotion/:id()",
    component: () => import("/vercel/path0/pages/promotion/[id].vue")
  },
  {
    name: "promotion-make-gathering",
    path: "/promotion/make-gathering",
    component: () => import("/vercel/path0/pages/promotion/make-gathering.vue")
  },
  {
    name: "promotion-myLifeConcert",
    path: "/promotion/myLifeConcert",
    component: () => import("/vercel/path0/pages/promotion/myLifeConcert.vue")
  },
  {
    name: "publishing-chat-room",
    path: "/publishing/chat-room",
    component: () => import("/vercel/path0/pages/publishing/chat-room.vue")
  },
  {
    name: "recommend-login-before",
    path: "/recommend/login/before",
    component: () => import("/vercel/path0/pages/recommend/login/before.vue")
  },
  {
    name: "recommend-login",
    path: "/recommend/login",
    component: () => import("/vercel/path0/pages/recommend/login/index.vue")
  },
  {
    name: "recommend-result-schedule",
    path: "/recommend/result/schedule",
    component: () => import("/vercel/path0/pages/recommend/result/schedule.vue")
  },
  {
    name: "recommend-result-waiting",
    path: "/recommend/result/waiting",
    component: () => import("/vercel/path0/pages/recommend/result/waiting.vue")
  },
  {
    name: "recommend-searching",
    path: "/recommend/searching",
    component: () => import("/vercel/path0/pages/recommend/searching.vue")
  },
  {
    name: "recommend-survey",
    path: "/recommend/survey",
    component: () => import("/vercel/path0/pages/recommend/survey.vue")
  },
  {
    name: "redirect-platform-to",
    path: "/redirect/:platform()/:to()",
    component: () => import("/vercel/path0/pages/redirect/[platform]/[to].vue")
  }
]